export default (state, action) => {
  const { selection } = state;
  const { itemId } = action.payload;
  return { ...state, selection: selection.filter(givenId => givenId !== itemId) };
};
